<div class="row">
  <div class="col-4">
    <slot name="controls" />
  </div>
  <div class="col-8">
    <slot name="results" />
  </div>
</div>
